import React, { Fragment } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    ROUTE_ROOT,
    ROUTE_LOGIN,
    ROUTE_PARTNER_SIGNUP,
    ROUTE_RESEARCH,
    ROUTE_RESOURCES,
    ROUTE_ADMIN,
    ROUTE_EXPORT,
    ROUTE_MONITORING,
    ROUTE_404,
    ROUTE_DASHBOARD,
    ROUTE_TAGGING,
    ROUTE_CHALLENGES,
    ROUTE_DOWNLOAD_CHALLENGES,
    ROUTE_CHALLENGE,
    ROUTE_CAMPAIGNS,
    ROUTE_CAMPAIGN,
    ROUTE_PAYMENTS,
    ROUTE_WELCOME,
    ROUTE_SIGNUP,
    ROUTE_SEGMENTS,
    FORGOT_PASSWORD,
    ROUTE_INVITE,
    ROUTE_CHALLENGE_CREATE,
    ROUTE_CHALLENGE_EDIT,
    ROUTE_ANALYZE_RESEARCH,
    // ROUTE_NOT_FOUND
} from './constants';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import SideBar from './SideBar';
import Header from './Header';
import Footer from './Footer';

// Screens/Pages
import LoginPage from '../screens/auth/LoginScreen';
import ForgotPassword from '../screens/auth/ForgotPassword';
import Payments from '../screens/auth/Payments';
import Signup from '../screens/auth/Signup';
import Challenges from '../screens/Challenges';
import Campaigns from '../screens/Campaigns';
import Tagging from '../screens/Tagging';
import Dashboard from '../screens/Dashboard';
import DownloadChallenges from '../screens/DownloadChallenges';
import WelcomeScreen from '../screens/WelcomeScreen';
import InviteScreen from '../screens/InviteScreen';
import Research from '../screens/Research';
import Resources from '../screens/Resources';
import NotFound from '../screens/404';

import Authentication from '../screens/auth/Authentication';

import './styles.scss';
import Challenge from '../screens/Challenge';
import Campaign from '../screens/Campaign';
import Segments from '../screens/Segments';
import MonitorStats from '../screens/Monitor';

import CheckForPermissions from './CheckForPermissions';

import {
    DASHBOARD_VIEW,
    CHALLENGE_VIEW,
    CAMPAIGN_LIST_VIEW,
    CAMPAIGN_VIEW,
    CHALLENGE_DETAILS_VIEW,
    SEGMENTS_VIEW,
    REPORT_VIEW,
    RESOURCES_VIEW,
    RESEARCH_VIEW,
    ADMIN_VIEW,
    DASHBOARD_ADMIN_VIEW,
    MULTILITTER_VIEW,
} from '../screens/auth/constants';
import Authorization from '../screens/auth/Authorization';
import Admin from '../screens/Admin';
import Export from '../screens/Export';
import PartnerSignup from '../screens/auth/PartnerSignup';
import RouterChangeTracker from './RouteChangeTracker';
import { Beforeunload } from 'react-beforeunload';
import { isUserLoggedIn, getUser } from '../screens/auth/selectors';
import { GAUserId, GAevent } from '../analytics';
import { Category, Action } from '../analytics/constants';
import CreateChallenge from '../screens/CreateChallenge';
import EditChallenge from '../screens/EditChallenge';
import Analyze from '../screens/Analyze';

function Navigation({ isUserLoggedIn, user }) {
    if (isUserLoggedIn) {
        const { id, fullName, role, rolePermissions } = user;
        const { roleId } = rolePermissions;
        GAUserId(id);
        GAevent(
            Action.set_user_role_id,
            Category.user_detail,
            roleId,
            null,
            true,
        );
        GAevent(Action.set_user_role, Category.user_detail, role, null, true);
        GAevent(
            Action.set_username,
            Category.user_detail,
            fullName,
            null,
            true,
        );
    }

    if (!isUserLoggedIn && window.location.pathname.startsWith('/invite')) {
        localStorage.setItem('invite', window.location.pathname);
    }

    return (
        <Router>
            <div>
                <Switch>
                    <PublicRoute exact path={ROUTE_LOGIN}>
                        <LoginPage />
                    </PublicRoute>
                    <PublicRoute exact path={FORGOT_PASSWORD}>
                        <ForgotPassword />
                    </PublicRoute>
                    {/* It is only atest path will be deleted later */}
                    <ProtectedRoute exact path={ROUTE_PAYMENTS}>
                        <Payments />
                    </ProtectedRoute>
                    <ProtectedRoute exact path={ROUTE_PARTNER_SIGNUP}>
                        <Beforeunload
                            onBeforeunload={() =>
                                `If you exit this page, your account will not be created. Please fill out the form & click ‘Save’ before leaving the site.`
                            }
                        >
                            <PartnerSignup />
                        </Beforeunload>
                    </ProtectedRoute>
                    <PublicRoute exact path={ROUTE_SIGNUP}>
                        <Signup />
                    </PublicRoute>
                    <Authentication>
                        <Fragment>
                            <div className="container-fluid bg-wrapper overflow-hidden">
                                <div className="row min-vh-100">
                                    <Header />
                                    <SideBar />
                                    <main className="dashboardContentBox col-md-10 col-lg-11 offset-md-2 offset-lg-1 col-sm-8 offset-sm-2 pt-3">
                                        <CheckForPermissions>
                                            {/* tagging screen */}
                                            <Authorization
                                                accessToCheck={MULTILITTER_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={ROUTE_TAGGING}
                                                        >
                                                            <Tagging />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* dashboard screen */}
                                            <Authorization
                                                accessToCheck={DASHBOARD_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={[
                                                                ROUTE_DASHBOARD,
                                                                ROUTE_ROOT,
                                                            ]}
                                                        >
                                                            <Dashboard />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* Create Challenge Screen */}
                                            <Authorization
                                                accessToCheck={
                                                    CHALLENGE_DETAILS_VIEW
                                                }
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_CHALLENGE_CREATE
                                                            }
                                                        >
                                                            <CreateChallenge />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* challenges screen */}
                                            <Authorization
                                                accessToCheck={CHALLENGE_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_CHALLENGES
                                                            }
                                                        >
                                                            <Challenges />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* download challenges screen */}
                                            <Authorization
                                                accessToCheck={REPORT_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_DOWNLOAD_CHALLENGES
                                                            }
                                                        >
                                                            <DownloadChallenges />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* challenges details screen */}
                                            <Authorization
                                                accessToCheck={
                                                    CHALLENGE_DETAILS_VIEW
                                                }
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_CHALLENGE
                                                            }
                                                        >
                                                            <Challenge />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* challenges edit screen */}
                                            <Authorization
                                                accessToCheck={
                                                    CHALLENGE_DETAILS_VIEW
                                                }
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_CHALLENGE_EDIT
                                                            }
                                                        >
                                                            <EditChallenge />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* campaigns screen */}
                                            <Authorization
                                                accessToCheck={
                                                    CAMPAIGN_LIST_VIEW
                                                }
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_CAMPAIGNS
                                                            }
                                                        >
                                                            <Campaigns />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* campaign details screen */}
                                            <Authorization
                                                accessToCheck={CAMPAIGN_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_CAMPAIGN
                                                            }
                                                        >
                                                            <Campaign />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* segments screen */}
                                            <Authorization
                                                accessToCheck={SEGMENTS_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_SEGMENTS
                                                            }
                                                        >
                                                            <Segments />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* research view */}
                                            <Authorization
                                                accessToCheck={RESEARCH_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_RESEARCH
                                                            }
                                                        >
                                                            <Research />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />
                                            {/* resources screen */}
                                            <Authorization
                                                accessToCheck={RESOURCES_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_RESOURCES
                                                            }
                                                        >
                                                            <Resources />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* Admin screen */}
                                            <Authorization
                                                accessToCheck={ADMIN_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={ROUTE_ADMIN}
                                                        >
                                                            <Admin />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* Export screen */}
                                            <Authorization
                                                accessToCheck={ADMIN_VIEW}
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={ROUTE_EXPORT}
                                                        >
                                                            <Export />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* research screen */}
                                            <ProtectedRoute
                                                exact
                                                path={ROUTE_ANALYZE_RESEARCH}
                                            >
                                                <Analyze />
                                            </ProtectedRoute>

                                            {/* Monitor Stats screen */}
                                            <Authorization
                                                accessToCheck={
                                                    DASHBOARD_ADMIN_VIEW
                                                }
                                                onApproval={() => {
                                                    return (
                                                        <ProtectedRoute
                                                            exact
                                                            path={
                                                                ROUTE_MONITORING
                                                            }
                                                        >
                                                            <MonitorStats />
                                                        </ProtectedRoute>
                                                    );
                                                }}
                                            />

                                            {/* Monitor Stats screen */}
                                            <ProtectedRoute path={ROUTE_INVITE}>
                                                <InviteScreen />
                                            </ProtectedRoute>

                                            {/* Payments route, to upgrade user */}
                                            <ProtectedRoute
                                                exact
                                                path={ROUTE_PAYMENTS}
                                            >
                                                <Payments />
                                            </ProtectedRoute>
                                            {/* <ProtectedRoute exact path={ROUTE_INVITE}>
                      <WelcomeScreen />
                    </ProtectedRoute> */}
                                            {/* Welcome route, screen after payment */}
                                            <ProtectedRoute
                                                exact
                                                path={ROUTE_WELCOME}
                                            >
                                                <WelcomeScreen />
                                            </ProtectedRoute>

                                            <ProtectedRoute
                                                exact
                                                path={ROUTE_404}
                                            >
                                                <NotFound />
                                            </ProtectedRoute>
                                        </CheckForPermissions>
                                    </main>
                                </div>
                                <Footer />
                            </div>
                        </Fragment>
                    </Authentication>
                    {/* <PublicRoute exact path="/*">
            <NotFound />
          </PublicRoute> */}
                </Switch>
            </div>
            <RouterChangeTracker />
        </Router>
    );
}

Navigation.propTypes = {
    isUserLoggedIn: PropTypes.bool,
    user: PropTypes.object.isRequired,
};

Navigation.defaultProps = {
    isUserLoggedIn: false,
};

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: isUserLoggedIn(state),
        user: getUser(state),
    };
};

const ConnectedNavigation = connect(mapStateToProps)(Navigation);

export default ConnectedNavigation;
